"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../styles");
var Advantages_1 = __importDefault(require("./Advantages"));
var WhyUs = function (props) {
    return (react_1.default.createElement(styles_1.Section, { className: props.className },
        react_1.default.createElement(styles_1.SectionTitle, null, "\u041F\u043E\u0447\u0435\u043C\u0443 \u043D\u0430\u0441 \u0432\u044B\u0431\u0438\u0440\u0430\u044E\u0442"),
        react_1.default.createElement(Advantages_1.default, null)));
};
var SWhyUs = (0, styled_components_1.default)(WhyUs)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: 40px;\n\n    & ", " {\n        margin-bottom: 16px;\n    }\n"], ["\n    margin-bottom: 40px;\n\n    & ", " {\n        margin-bottom: 16px;\n    }\n"])), styles_1.LabelTitle);
exports.default = SWhyUs;
var templateObject_1;
